import {
  futuraPTProBook,
  futuraPTProDemi,
  futuraPTProLight,
  futuraPTProMedium,
  apercuMonoRegularPro,
  acuminproRegularWebfont,
  acuminproLightWebfont,
  acuminproMediumWebfont,
  acuminproBoldWebfont,
  acuminproSemiboldWebfont
} from "./fonts";

const fonts = {
  demi: `${futuraPTProDemi.style.fontFamily}, Arial Narrow Bold, Arial Narrow, Arial, sans-serif`,
  medium: `${futuraPTProMedium.style.fontFamily}, Arial Narrow, Arial, sans-serif`,
  book: `${futuraPTProBook.style.fontFamily}, Arial Narrow, Arial, sans-serif`,
  light: `${futuraPTProLight.style.fontFamily}, Arial Narrow, Arial, sans-serif`,
  apercu: `${apercuMonoRegularPro.style.fontFamily}`,
  acumin: `${acuminproRegularWebfont.style.fontFamily}`,
  acuminLight: `${acuminproLightWebfont.style.fontFamily}`,
  acuminBold: `${acuminproBoldWebfont.style.fontFamily}, sans-serif`,
  acuminMedium: `${acuminproMediumWebfont.style.fontFamily}, sans-serif`,
  acuminRegular: `${acuminproRegularWebfont.style.fontFamily}, sans-serif`,
  acuminSemiBold: `${acuminproSemiboldWebfont.style.fontFamily}, sans-serif`
};

const letterSpacing = {
  normal: "0.08rem",
  medium: "0.2rem",
  large: "0.32rem"
};

const fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  boldish: 600,
  bold: 700
};

const fontSizes = {
  21: "3.958rem", // 64px
  17: "3.020rem", // 48.32px
  13: "2.291rem", // 36px
  10: "2rem", // 32px
  9: "1.75rem", // 28px
  8: "1.625rem", // 26px
  6: "1.5rem", // 24px
  5: "1.333rem", // 21.33px
  4: "1.25rem", // 20px
  3: "1.1667rem", // 18.6772
  2: "1.125rem", // 18px
  1: "1rem", // 16px
  0: "0.937rem", // 14.992
  "-1": "0.875rem", // 14px
  "-2": "0.775rem", // 12.4px
  "-3": "0.770rem", // 12.32px
  "-4": "0.75rem", // 12px
  "-5": "0.677rem", // 10.832px
  "-10": "0.2rem" // superscript
};

const lineHeights = {
  21: "4.5rem", // 72 px
  17: "3.5rem", // 56 px
  13: "3rem", // 48 px
  8: "2.5rem", // 40 px
  6: "2.75rem", // 44 px
  5.5: "2.291rem", // 36px
  5: "2rem", // 32 px
  4: "1.875rem", // 30px
  3: "1.75rem", // 28px
  2: "1.625rem", // 26 px
  1: "1.5rem",
  0: "1.5rem", // 24 px
  "-1": "1rem", // 16 px
  "-2": "1rem",
  "-3": "1rem",
  "-4": "0.5rem", // 8 px
  "-5": "0.75rem" // 12px
};

const verticalAlignment = {
  1: "0.5rem", // superscript
  0: "0"
};

const space = {
  "-6": "0.15rem", // 2 px
  "-5": "0.75rem", // 12 px
  "-4": "0.625rem", // 10 px
  "-3": "0.55rem", // 8.8 px
  "-2": "0.25rem", // 4 px
  "-1": "0.5rem", // 8 px
  0: "0rem", // 0
  1: "1rem", // 16 px
  1.5: "1.25rem", // 20 px
  1.75: "1.31rem", // 21 px
  2: "1.5rem", // 24 px
  2.5: "1.75rem", // 28 px
  3: "2rem", // 32 px
  5: "2.5rem", // 40 px
  6: "2.75rem", // 44 px
  6.5: "3rem", // 48 px
  7: "3.25rem", // 52 px
  7.5: "3.75rem", // 60 px
  8: "4rem", // 64 px
  9: "4.5rem", // 72 px
  10: "5rem", // 80 px
  11: "5.5rem", // 88 px
  12: "6.0rem", // 96 px
  13: "6.5rem", // 104 px
  14: "7.0rem", // 112 px
  15: "8rem", // 128 px
  21: "10.5rem", // 168 px
  28: "13rem", // 208 px
  35: "16.5rem", // 264 px
  38: "18rem" // 288 px
};

export {
  fonts,
  fontWeights,
  fontSizes,
  lineHeights,
  space,
  letterSpacing,
  verticalAlignment
};
